<template>

    <m-edit1/>

    <m-login-1 v-bind='{...{"image":"https:\/\/api.drgeramiclinic.ir\/storage\/assets\/c722fd66db5db5f93ddaa9706cfda83a1e85764770f4c33cff695a4cc6573cfb-removebg-preview.png","showPanels":false,"imageParentClass":"col-lg-6 d-none d-lg-flex","defaultPanel":null},...{}}' :style='""' class="ag-login" >
                <template #classic-login-p-1-top>   <m-span v-bind='{...{},...{}}' :style='""' class="ag-login-title" >
                <template #default>به کلینیک دکتر امین گرامی خوش آمدید   </template>
                </m-span><m-span v-bind='{...{},...{}}' :style='""' class="ag-login-sub" >
                <template #default>زیبایی تو، امضای ما   </template>
                </m-span></template>
                
                <template #classic-login-p-1-bottom>   </template>
                
                <template #two-step-login-p-1-top>   <m-span v-bind='{...{},...{}}' :style='""' class="ag-login-title" >
                <template #default>به کلینیک دکتر امین گرامی خوش آمدید   </template>
                </m-span><m-span v-bind='{...{},...{}}' :style='""' class="ag-login-sub" >
                <template #default>زیبایی تو، امضای ما   </template>
                </m-span></template>
                
                <template #two-step-login-p-1-bottom>   </template>
                </m-login-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mLogin1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/Login/Login1'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span';

export default {
    name: 'HomeView',
    components: {mEdit1, mLogin1,mSpan },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
